import fetchExpresso from 'utility/fetchExpresso';

export async function getProductGroups(eventId) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/product_groups`);

    if (!isSuccessful(response)) {
        throw new Error('Unable to load ticket groups');
    }

    const data = await response.json();
    return data.groups ?? [];
}

export async function getProductGroup(eventId, productGroupId) {
    const response = await fetchExpresso(
        `/apiv2/events/${eventId}/product_groups/${productGroupId}`,
    );

    if (!isSuccessful(response)) {
        throw new Error('Unable to load ticket group');
    }

    return response.json();
}

export async function createProductGroup(eventId, name) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/product_groups`, {
        method: 'POST',
        body: { name },
    });

    if (!isSuccessful(response)) {
        throw new Error('Unable to create ticket group');
    }
}

export async function updateProductGroup(eventId, productGroupId, name) {
    const response = await fetchExpresso(
        `/apiv2/events/${eventId}/product_groups/${productGroupId}`,
        {
            method: 'PUT',
            body: { name },
        },
    );

    if (!isSuccessful(response)) {
        throw new Error('Unable to update ticket group');
    }
}

export async function updateProductGroupSort(eventId, sort) {
    const response = await fetchExpresso(`/apiv2/events/${eventId}/product_groups/sort`, {
        method: 'PUT',
        body: { sort },
    });

    if (!isSuccessful(response)) {
        throw new Error('Unable to change ticket group order');
    }
}

export async function deleteProductGroup(eventId, productGroupId) {
    const response = await fetchExpresso(
        `/apiv2/events/${eventId}/product_groups/${productGroupId}`,
        { method: 'DELETE' },
    );

    if (!isSuccessful(response)) {
        throw new Error('Unable to delete ticket group');
    }
}

function isSuccessful(response) {
    return response.status >= 200 && response.status < 300;
}
